import { MaterialUICore, axiomTokens } from '@iclinic/design-system';

const { styled } = MaterialUICore;
const { color, spacing, font, border } = axiomTokens;

export const Link = styled('a')(() => ({
  textDecoration: 'none',
  '&:hover': {
    textDecoration: 'none',
  },
  '&:focus': {
    textDecoration: 'none',
  },
  '&:visited': {
    textDecoration: 'none',
  },
  color: color.typeface.pure,
}));

export const ButtonStyled = styled('button')(({ theme }) => ({
  width: '96px',
  height: '80px',
  backgroundColor: 'white',
  borderRadius: border.radius.sm,
  border: `${border.width.xs} solid ${theme.palette.grey[100]}`,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  padding: spacing[2],
  '&:hover': {
    borderColor: theme.palette.primary.main,
    '& svg': {
      color: theme.palette.primary.main,
    },
  },
  '& svg': {
    color: theme.palette.grey[300],
  },
}));

export const TopContainer = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}));

export const TextContainer = styled('div')(({ theme }) => ({
  textAlign: 'left',
  fontSize: 10,
  fontWeight: font.weight.bold,
  fontStyle: 'normal',
  letterSpacing: 0.444444,
  lineHeight: '12px',
  fontFamily: theme.typography.fontFamily,
}));
